import Link from "next/link";

import CookiePreferencesLink from "@/app/components/legal/CookiePreferencesLink";

export default function ArticleFooter() {
  const linkClassName =
    "underline decoration-slate-500 underline-offset-4 transition hover:text-white hover:decoration-slate-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70";

  return (
    <footer
      data-nosnippet
      className="border-t border-slate-800 bg-slate-950 text-white"
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-6 px-6 py-8 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <p className="text-lg font-semibold">Eclat Institute</p>
          <p className="mt-2 max-w-xl text-sm leading-6 text-slate-300">
            Study resources and practical support for secondary and JC students
            in Singapore.
          </p>
        </div>
        <nav aria-label="Article footer" className="text-sm text-slate-200">
          <ul className="flex flex-wrap gap-x-5 gap-y-3">
            <li>
              <Link className={linkClassName} href="/blog">
                All articles
              </Link>
            </li>
            <li>
              <Link className={linkClassName} href="/locations">
                Locations
              </Link>
            </li>
            <li>
              <Link className={linkClassName} href="/team">
                Our team
              </Link>
            </li>
            <li>
              <Link className={linkClassName} href="/legal/privacy">
                Privacy
              </Link>
            </li>
            <li>
              <CookiePreferencesLink className={linkClassName} />
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  );
}
